import React from "react";
import StoreCard from "../../components/StoreCard";
import firebase from "firebase/app";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedEmirates,
  setSelectedRegion,
} from "../../redux/reducers/emiratesAndRegion.reducer";
import {
  setSelectedStores,
  setIsAllStoresSelected,
} from "../../redux/reducers/stores.reducer";
import { Grid } from "@mui/material";
import StoreFilters from "../../components/StoreFilters";
import algoliasearch from "algoliasearch";
import FullScreenLoading from "../../components/FullScreenLoading";
import { useTranslation } from "react-i18next";

const SuperMarkets = () => {
  const [markets, setMarkets] = useState([]);
  const [loading, setLoading] = useState();
  const [searchRecords, setSearchRecords] = React.useState(null);
  const {t} = useTranslation()
  const dispatch = useDispatch();
  const client = algoliasearch(
    "X9G4EYXZG2",
    "15984b76eabf34113d9384dc4fd2f642"
  );
  const index = client.initIndex("stores");
  const selectedEmirate = useSelector(
    (state) => state.emiratesAndRegion.selectedEmirates
  );
  const selectedRegion = useSelector(
    (state) => state.emiratesAndRegion.selectedRegion
  );
  const selectedStores = useSelector((state) => state.stores.selectedStores);
  const userData = useSelector((state) => state.auth.user);
  const getMarkets = async () => {
    let ref = firebase.firestore().collection("stores");
    let stores = [];
    const storesList = await ref.get();
    for (let index = 0; index < storesList.docs.length; index++) {
      let element = storesList.docs[index].data();
      stores.push(element);
    }
    setLoading(false);
    setMarkets(stores);
  };

  React.useEffect(() => {
    setLoading(true);
    getMarkets();
  }, []);

  const loadData = async () => {
    // setLoading(true);
    debugger;
    if (selectedEmirate === "All") {
      const storesData = await (
        await firebase.firestore().collection("stores").get()
      ).docs.map((item) => item.data());
      // storesData.length > 0 ? storesData :
      setSearchRecords(null);
      if (loading) setLoading(false);
    } else {
      const areas =
        selectedRegion && selectedRegion.length > 0
          ? selectedRegion.map((area) => `zone:${area}`)
          : [];
      const emirates =
        selectedEmirate && selectedEmirate.length > 0
          ? selectedEmirate.map((emarite) => `emarite:${emarite}`)
          : [];
      const facts =
        areas.length > 0 && selectedEmirate.length > 0
          ? [areas, emirates]
          : areas.length > 0 && !selectedEmirate.length > 0
          ? [areas]
          : !areas.length > 0 && selectedEmirate.length > 0
          ? [emirates]
          : [];
      await index
        .search("", {
          facetFilters: facts,
          facets: ["*"],
        })
        .then((results) => {
          setSearchRecords(results.hits);
          if (loading) setLoading(false);
        })
        .catch((err) => {
          console.log("err:", err);
          if (loading) setLoading(false);
        });
    }
  };

  React.useEffect(() => {
    debugger;
    if (selectedEmirate && selectedEmirate != null) {
      loadData();
    } else {
      dispatch(setSelectedEmirates("All"));
      dispatch(setSelectedRegion([]));
    }
  }, [selectedEmirate, selectedRegion]);

  const handleCheckAllChange = async (checked) => {
    console.log("in");
    if (checked) {
      const ids = searchRecords.map((item) => item.id);
      console.log("IDS:", ids);
      dispatch(setSelectedStores(ids));
      if (!userData?.isAnonymous) {
        await firebase
          .firestore()
          .collection("users")
          .doc(userData.id)
          .update({ stores: ids });

        // await updateUserInfo({ ...userInfo, stores: ids });
      }
    } else {
      dispatch(setSelectedStores([]));
      if (!userData?.isAnonymous) {
        await firebase
          .firestore()
          .collection("users")
          .doc(userData.id)
          .update({ stores: [] });
      }
    }
  };
  React.useEffect(() => {
    if (
      selectedStores &&
      selectedStores.length > 0 &&
      searchRecords &&
      searchRecords.length > 0
    ) {
      const ids = searchRecords.map((item) => item.id);
      const isAllSelected = ids.filter(
        (item) => !selectedStores.includes(item)
      );
      if (isAllSelected.length <= 0 && ids.length === selectedStores.length) {
        dispatch(setIsAllStoresSelected(true));
      } else {
        dispatch(setIsAllStoresSelected(false));
      }
    } else {
      dispatch(setIsAllStoresSelected(false));
    }
  }, [selectedStores, searchRecords, selectedEmirate, selectedRegion]);

  if (loading) {
    return <FullScreenLoading />;
  }

  return (
    <Grid
      container
      spacing={2}
      justifyContent={"center"}
      marginTop={{ sm: 15, xs: 15, md: 15, lg: 15, xl: 15 }}
    >
      <Grid
        item
        xs={12}
        style={{ display: "flex", flexDirection: "column", flex: 0.6 }}
      >
        <StoreFilters />
      </Grid>
      <Grid item xs={8} style={{ display: "flex", flexWrap: "wrap" }}>
        <StoreCard
          key={"Select all stores"}
          handleAllCheck={handleCheckAllChange}
        />
        {markets &&
          markets.length > 0 &&
          !searchRecords &&
          markets?.map((m, index) => (
            <StoreCard
              key={index}
              store={m}
              handleAllCheck={handleCheckAllChange}
            />
          ))}
        {searchRecords &&
          searchRecords?.length > 0 &&
          searchRecords?.map((store, index) => (
            <StoreCard key={index} store={store} handleCheck={() => {}} />
          ))}
        {searchRecords && searchRecords?.length == 0 && (
          <p style={{ textAlign: "center", marginLeft: '10px', marginRight: '10px' }}>
            {t('general.noSearchFound')}
          </p>
        )}
      </Grid>
    </Grid>
  );
};

export default SuperMarkets;
